<template>
  <div data-v-042cdcc3="" class="screen-more" v-show="loadingstart || loadingempty">
          <div data-v-042cdcc3 v-show="loadingstart">
          <div data-v-ad8c786a data-v-042cdcc3 class="spinner">
            <div data-v-ad8c786a class="spinner-container container1">
              <div data-v-ad8c786a class="circle1"></div>
               <div data-v-ad8c786a class="circle2"></div>
                <div data-v-ad8c786a class="circle3"></div> 
                <div data-v-ad8c786a class="circle4"></div>
            </div> 
            <div data-v-ad8c786a class="spinner-container container2">
                  <div data-v-ad8c786a class="circle1"></div>
                   <div data-v-ad8c786a class="circle2"></div> 
                   <div data-v-ad8c786a class="circle3"></div> 
                   <div data-v-ad8c786a class="circle4"></div>
            </div>
            <div data-v-ad8c786a class="spinner-container container3">
                <div data-v-ad8c786a class="circle1"></div>
                <div data-v-ad8c786a class="circle2"></div> 
                <div data-v-ad8c786a class="circle3"></div> 
                <div data-v-ad8c786a class="circle4"></div>
            </div>
            </div>
  </div>
<span data-v-042cdcc3="" v-show="loadingempty">没有更多数据了...</span>
 </div>
</template>
<script>
 export default {
      props:{
          loadingstart:{
              type:Boolean,
              default:false
          },
          loadingempty:{
              type:Boolean,
              default:false
          }
      }  
    
   }
</script>
<style scoped>
.screen-more[data-v-042cdcc3] {
    width: 150px;
    height: 40px;
    margin: 10px auto 20px;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    color: #999;
}
.spinner[data-v-ad8c786a] {
    margin: 100px auto;
    width: 20px;
    height: 20px;
    position: relative;
}
.spinner .spinner-container[data-v-ad8c786a] {
    position: absolute;
    width: 100%;
    height: 100%;
}
.container1>div[data-v-ad8c786a], .container2>div[data-v-ad8c786a], .container3>div[data-v-ad8c786a] {
    width: 6px;
    height: 6px;
    background-color: #333;
    border-radius: 100%;
    position: absolute;
    animation: bouncedelay-data-v-ad8c786a 1.2s infinite ease-in-out;
    animation-fill-mode: both;
}
.circle1[data-v-ad8c786a] {
    top: 0;
    left: 0;
}
.container1 .circle2[data-v-ad8c786a] {
    animation-delay: -.9s;
}
.container1 .circle3[data-v-ad8c786a] {
    animation-delay: -.6s;
}
.container1 .circle4[data-v-ad8c786a] {
    animation-delay: -.3s;
}
.container2[data-v-ad8c786a] {
    transform: rotate(45deg);
}
.container2 .circle1[data-v-ad8c786a] {
    animation-delay: -1.1s;
}
.container2 .circle2[data-v-ad8c786a] {
    animation-delay: -.8s;
}
.container2 .circle3[data-v-ad8c786a] {
    animation-delay: -.5s;
}
.container2 .circle4[data-v-ad8c786a] {
    animation-delay: -.2s;
}
.container3[data-v-ad8c786a]{
    transform: rotate(90deg);
}
.container3 .circle1[data-v-ad8c786a] {
    animation-delay: -1s;
}
.container3 .circle2[data-v-ad8c786a] {
    animation-delay: -.7s;
}
.container3 .circle3[data-v-ad8c786a] {
    animation-delay: -.4s;
}
.container3 .circle4[data-v-ad8c786a] {
    animation-delay: -.1s;
}
.screen-more[data-v-042cdcc3] {
    width: 150px;
    height: 40px;
    margin: 10px auto 20px;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    color: #999;
}
</style>

